export default "__VITE_ASSET__C_nfsIW0__"